import { useQuery } from '@tanstack/react-query'

import { axios } from '@apps-common/lib/axios'
import { ExtractFnReturnType, QueryConfig } from '@apps-common/lib/react-query'
import { ICompanyListModel } from '@apps-common/types/portal/company'

export const getCompanies = async (name: string, type: string): Promise<ICompanyListModel[]> =>
  axios.get(`/unit/getcompaniesselectlist?search=${name}&type=${type}`).then((res) => res.data?.data)

type QueryFnType = typeof getCompanies

type Props = {
  config?: QueryConfig<QueryFnType>
  name: string
  type: string
}

export const useGetCompanies = ({ config, name, type }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getCompanies', name, type],
    queryFn: () => getCompanies(name, type)
  })
